const enum ErrorCode {
  Unknown = 0,
  CrossTenantAccess = 1000,
}

export default ErrorCode;
